import { Pipe, PipeTransform } from '@angular/core';
import { SpedCollectionStudentToTeamMember } from '../../../../student-document-home/sped-student-document-cards/sped-student-document-cards.model';

@Pipe({
  name: 'maintainTeamMemberHeaderName'
})
export class MaintainTeamMemberHeaderNamePipe implements PipeTransform {

  transform(headerName: string, teamMembers: SpedCollectionStudentToTeamMember[]): string {
    if (headerName == 'FormName') {
      return 'Form Name';
    } else {
      const memberName: string = teamMembers.find(x => x.TeamMemberId == parseInt(headerName, 10)).TeamMemberName;
      return memberName;
    }
  }
}